module.exports = __webpack_public_path__ + "static/criterios_precatorios-9b8ed232c6b50c8175b56139fac7e9f6.pdf";